import { createDispute } from '../../api/disputes';
import { reportAttemptToCreateDispute, reportDisputeCreated, reportDisputeCreationFailed } from '../../utils/reporter';

export const disputes = {
  effects: {
    async createDispute(createDisputRequest) {
      try {
        reportAttemptToCreateDispute();
        const dispute = await createDispute(createDisputRequest);
        reportDisputeCreated();
        return dispute;
      } catch (err) {
        reportDisputeCreationFailed(err);
        throw err;
      }
    }
  },
  reducers: null,
  state: null
};
